document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const headerHeight = document.querySelector('sticky-header').offsetHeight;
    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      window.scrollTo({
            top: targetElement.offsetTop - headerHeight,
        behavior: 'smooth'
      });
    }
  });
});